var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiny(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiny_logo",
    "data-name": "tiny logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.28,
    height: 34.292,
    viewBox: "0 0 34.28 34.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(6.169 9.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M62.486,67.221A.6.6,0,1,1,63,66.541.6.6,0,0,1,62.486,67.221ZM62.333,66.1a.53.53,0,1,0,.6.454A.53.53,0,0,0,62.333,66.1Zm.409.794c-.027,0-.043,0-.076.008-.071.01-.1-.041-.1-.1l-.007-.054c0-.034-.01-.072-.044-.087s-.037-.011-.121,0c-.059.008-.081.017-.076.052l.006.044a.6.6,0,0,0,.019.105.038.038,0,0,0,.046.026c.014,0,.027-.008.04-.01a.028.028,0,0,1,.031.025c0,.02-.014.033-.033.036-.035,0-.072,0-.116.006s-.07.019-.113.025a.033.033,0,0,1-.041-.026.028.028,0,0,1,.023-.033c.014,0,.028,0,.042,0a.038.038,0,0,0,.038-.037.644.644,0,0,0-.01-.106l-.028-.209a.614.614,0,0,0-.019-.105.038.038,0,0,0-.046-.026c-.014,0-.027.008-.04.01a.028.028,0,0,1-.031-.025.033.033,0,0,1,.033-.036c.05-.007.094,0,.138-.009.073-.01.119-.026.157-.031a.255.255,0,0,1,.134.009.142.142,0,0,1,.079.112c.012.09-.034.134-.114.159v0c.089,0,.112.046.122.127l.006.041c.005.039.009.062.057.056l.039-.008a.031.031,0,0,1,.038.026A.033.033,0,0,1,62.742,66.892Zm-.23-.329a.1.1,0,0,0,.032-.094c-.011-.081-.073-.1-.149-.085-.095.013-.121.033-.116.064l.019.139c0,.021.006.022.03.019l.07-.01A.277.277,0,0,0,62.512,66.562ZM61.819,69.3l-.941,1.237a1.35,1.35,0,0,1-.179.192l.105.774a1.343,1.343,0,0,1-2.662.362l-.116-.856c-.035-.022-.069-.044-.1-.07L56.685,70a1.343,1.343,0,0,1,1.626-2.138l.777.591.591-.777A1.343,1.343,0,0,1,61.819,69.3ZM56.3,72.751l-.011.028a1.344,1.344,0,0,1-2.064.579l-1.01-.78a1.343,1.343,0,0,1-2.668.309l-.4-2.951a1.343,1.343,0,0,1,2.157-1.24l.026.018.975.764a1.343,1.343,0,0,1,2.664-.346l.4,2.969a1.335,1.335,0,0,1-.067.636Zm-7.176,1.7A1.343,1.343,0,0,1,47.615,73.3l-.4-2.963a1.343,1.343,0,0,1,2.662-.362l.4,2.964A1.343,1.343,0,0,1,49.127,74.446ZM45.9,71.869l-.172.023.222,1.631a1.343,1.343,0,0,1-2.662.362l-.222-1.631-.171.023a1.343,1.343,0,1,1-.362-2.661l3.005-.409a1.343,1.343,0,1,1,.362,2.661Zm.111,3.137,3.006-.409a1.343,1.343,0,1,1,.362,2.661l-.172.023.222,1.63a1.343,1.343,0,0,1-2.662.362l-.222-1.63-.171.023a1.343,1.343,0,1,1-.362-2.661Zm5.282.068a1.343,1.343,0,0,1,1.073-.93l.03,0,.03,0a1.343,1.343,0,0,1,1.283.609l1.954,2.7a1.343,1.343,0,0,1-2.124,1.644l-.576-.8-.342.922A1.343,1.343,0,0,1,50.138,78.2Zm5.576-1.536c.071-.01.12-.014.21-.028l1.153-.157A1.807,1.807,0,0,1,60.271,74.9a2.082,2.082,0,0,1-1.583,2.012l.1.764a1.343,1.343,0,0,1-2.662.362l-.409-3A1.329,1.329,0,0,1,56.874,73.537Z",
    transform: "translate(-41.375 -66.019)",
    fill: "#1228f3",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1.164 1.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M9.1,21.189a1.294,1.294,0,0,1-1.2-1.773,16.6,16.6,0,0,1,2.957-4.593,17.612,17.612,0,0,1,5.489-4.2,1.293,1.293,0,1,1,1.114,2.335A15.349,15.349,0,0,0,10.3,20.374,1.294,1.294,0,0,1,9.1,21.189Z",
    transform: "translate(-7.806 -10.495)",
    fill: "#1228f3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 13.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1.731,96.655a1.294,1.294,0,0,1-1.252-.974,18.044,18.044,0,0,1-.211-7.227,1.293,1.293,0,1,1,2.5.667,16.1,16.1,0,0,0,.218,5.922,1.295,1.295,0,0,1-1.254,1.613Z",
    transform: "translate(0 -87.493)",
    fill: "#1228f3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1.614 22.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M12.743,157.012a1.293,1.293,0,0,1-1.137-.674l-.62-1.138a1.293,1.293,0,1,1,2.271-1.238l.62,1.138a1.294,1.294,0,0,1-1.134,1.913Z",
    transform: "translate(-10.828 -153.287)",
    fill: "#1228f3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(6.057 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M51.7,34.292a16.973,16.973,0,0,1-10.583-3.655,1.293,1.293,0,1,1,1.6-2.034,14.41,14.41,0,0,0,8.985,3.1A14.559,14.559,0,1,0,48.4,2.963a1.293,1.293,0,0,1-.584-2.52A17.232,17.232,0,0,1,51.7,0,17.146,17.146,0,0,1,63.825,29.27,17.033,17.033,0,0,1,51.7,34.292Z",
    transform: "translate(-40.623 0)",
    fill: "#1228f3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiny);
export default __webpack_public_path__ + "static/media/tiny.47722e2785da3c0130e39c235bf63758.svg";
export { ForwardRef as ReactComponent };